import { Controller, useFormContext } from 'react-hook-form'

import { Text } from '@wartek-id/text-v1'
import { Separator } from '@wartek-id/separator'
import { Radio, RadioGroup } from '@wartek-id/radio'

import type {
  TFormValues,
  TStyle,
} from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/types'
import type { FC } from 'react'

type Props = {
  hasData: boolean
  title: string
  value: React.ReactNode
  prefix: string
}

export const DialogFormField: FC<Props> = ({
  hasData,
  title,
  value,
  prefix,
}) => {
  const { control } = useFormContext<TFormValues>()

  const options: Record<TStyle, string> = {
    CONFIRMED: 'Ya, data benar',
    REJECTED: 'Tidak, data salah',
  }

  return (
    <div className="border border-subdued rounded p-4 space-y-4">
      <div className="space-y-1 py-2">
        <Text variant="subheading" color="disabled" className="uppercase">
          {title}
        </Text>
        {value && value}
      </div>

      {hasData && (
        <>
          <Separator />
          <Controller
            control={control}
            rules={{ required: true }}
            name={`${prefix}.value` as 'pengawas.value' | 'dinas.value'}
            render={({ field: { onChange, value: groupValue } }) => (
              <RadioGroup
                name={`confirm-${prefix}-group`}
                className="flex flex-col gap-4"
                onChange={(value) => onChange(value)}
                value={groupValue}
              >
                {Object.entries(options).map(([value, text]) => (
                  <Radio value={value} key={value}>
                    <Text as="span">{text}</Text>
                  </Radio>
                ))}
              </RadioGroup>
            )}
          />
        </>
      )}
    </div>
  )
}
